/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Weighing_Tea_TypeInputs */

const vi_trace_weighing_tea_type = /** @type {(inputs: Trace_Weighing_Tea_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè`)
};

/**

* @param {Trace_Weighing_Tea_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_weighing_tea_type = /** @type {((inputs?: Trace_Weighing_Tea_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Weighing_Tea_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_weighing_tea_type(inputs)
});